import { Component, OnInit, Inject } from "@angular/core";

import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material";

@Component({
  selector: "thankYou",
  templateUrl: "thankYou.html"
})
export class ThankYouComponent {
  constructor(
    public snackRef: MatSnackBarRef<ThankYouComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}
  closeSnack(): void {
    this.snackRef.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/app/calendar/races/r1/thankYou.component.ts